import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import TMG_LOGO from "../Project Images/TMG_LOGO.jpg";
import "../CSS/header.css";

export const Header = () => {
  return (
    <>
      <Navbar bg="light" style={{ height: "100px", position: "fixed", width: "100%", top: 0, zIndex: 1000 }}>
        <Container>
          <Navbar.Brand as={Link} to="/" style={{ fontSize: "24px" }}>
            <img
              src={TMG_LOGO}
              height="100"
              className="d-inline-block align-top"
              alt="Techno Maven Group"
              id="headerImg"
            />
          </Navbar.Brand>
          <Nav className="justify-content-end" style={{ width: "50%" }}>
            <Nav.Link as={Link} to="/" className="navHeaders">
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className="navHeaders">
              About
            </Nav.Link>
            <Nav.Link as={Link} to="/work" className="navHeaders">
              Our Work
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className="navHeaders">
              Contact Us
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <div style={{ height: "100px" }} /> {/* Placeholder to prevent content from being overlapped */}
    </>
  );
};
